import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query';
import { fetchArticleById } from '../api/article';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { fetchCategoryById } from '../api/categories';
import ActuCardPlaceholder from '../components/ActuCardPlaceholder';
import IsEmpty from '../components/IsEmpty';
import ActuCard from '../components/ActuCard';
import { getFirstImageSrc, getTextFromHTML } from '../constants/functions';
import { actualitiesLink } from '../constants/endspoints';
import { placeholderImg } from '../constants/files';

const ActualityDetail = () => {

    const {id:actualityId} = useParams()

    // Fetch a single actuality by ID
    const { data: singleActuality, isLoading: isFetchingSingle, isError } = useQuery({
        queryKey: ['actuality', actualityId],
        queryFn: () => fetchArticleById(actualityId),
        enabled: !!actualityId,
    });


    // 3. Fetch All actualities by category
    const { data: actuCategory, isLoading: isFetchingActuCategory, isError: actuCategoryError } = useQuery({
        queryKey: ['categoryId', singleActuality?.data?.Category?.id],
        queryFn: () => fetchCategoryById(singleActuality?.data?.Category?.id),
        enabled: !!singleActuality,
    });
    
console.log(singleActuality);


    return (
        <div className='text-white mb-5 mt-2'>

            {/* Hero */}
            {
                isFetchingSingle?
                <>
                    <div className='bgcolor-hero-actuality mb-1 placeholder-wave'>
                        <div className='container-xxl h-100'>
                            <div className=' d-flex flex-column justify-content-end align-items-center text-center h-100 w-100 mx-auto' style={{maxWidth:'768px'}}>
                                <div>
                                    <span className="spinner-border spinner-border-sm" ></span>
                                    <span role="status" className='fs-5'>Chargement...</span>
                                </div>
                                <div className=' fs-2 placeholder col-12 bgcolor-primary'></div>
                            </div>
                        </div>
                    </div>
                    <div className='mx-auto placeholder-wave  container-xxl' style={{maxWidth:'768px'}}>
                        <div className='mb-2 placeholder bgcolor-primary' style={{height:'30vh', width:'100%'}}></div>

                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-12 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-10 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-11 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-10 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-12 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-11 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-9 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-11 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-10 bgcolor-primary'></p>
                        <p className='fs-9s text-opacity-75 lh-lg placeholder col-12 bgcolor-primary'></p>

                        <hr/>

                        <div className=' d-flex justify-content-end'>
                            <span className='fst-italic fs-9s placeholder col-3 bgcolor-primary'></span>
                        </div>

                    </div>
                </>
                :isError?
                    <IsEmpty icon={"fa-light fa-exclamation-circle mb-2"} message={"Une erreur c'est produite"} />
                :singleActuality?.data.status === false ?
                    <div className=' py-5 my-md-5 my-2'>
                        <IsEmpty icon={"fa-light fa-newspaper"} message={"Cette actualité n'est pas disponible "} />
                    </div>
                :<>
                    <div className='bgcolor-hero-actuality mb-1'>
                        <div className='container-xxl h-100'>
                            <div className=' d-flex flex-column justify-content-end align-items-center text-center h-100 w-100 mx-auto' style={{maxWidth:'768px'}}>
                                <h2 className=' fs-3 text-uppercase fw-bold'>{singleActuality?.data?.title}</h2>
                            </div>
                        </div>
                    </div>
                    <div className='mx-auto container-xxl' style={{maxWidth:'768px'}}>
        
                        <div className='d-flex flex-grow-0 justify-content-end'>
                            <span className=' px-2 py-0 mb-1 bgcolor-secondary text-truncate-1 fs-8s w-auto'>{singleActuality?.data?.Category?.name}</span>
                        </div>
                        <div className='tiptap' dangerouslySetInnerHTML={{__html: singleActuality?.data?.content}}></div>
        
                        <div className=' d-flex flex-wrap flex-column justify-content-center align-items-end'>
                            <p className='fs-8s opacity-75 mb-0'>{singleActuality?.data?.Category?.name}</p>
                            <p className='opacity-75 fs-8s mb-0'>{singleActuality?.data?.createdAt? format(singleActuality?.data?.createdAt, "dd MMM yyyy", {locale: fr}) : null}</p>
                        </div>

                        {/* Actualites de meme categorie */}
                        {
                            actuCategory?.articles?.filter((actu) => actu?.id !== parseInt(actualityId)).length > 0 &&
                            <div className='mt-4'>
                                <h4 className='fs-3 text-nowrap fw-bold me-md-0 me-2'>Dans la même catégorie</h4>
                                <hr className='mt-0 mb-1 border-white'/>
                                <div className=' mb-3 row justify-content-start align-items-start'>

                                    {
                                        isFetchingActuCategory?
                                        [1,2,3,4].map((item, index) => (
                                            <div key={index} className='col-lg-3 col-md-4 col-sm-6 mt-3'>
                                                <ActuCardPlaceholder/>
                                            </div>
                                        ))
                                        :actuCategoryError?
                                            <IsEmpty icon={"fa-light fa-exclamation-circle mb-2"} message={"Une erreur c'est produite"} />
                                        :actuCategory?.articles
                                        ?.filter((actu) => actu?.id !== parseInt(actualityId) && actu.status === true)
                                        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                        .slice(0, 4)
                                        .map((actuality, index) => {
                                            return (
                                                <div key={index} className='col-md-6 col-12 mt-4'>
                                                    <ActuCard 
                                                        image={getFirstImageSrc(actuality?.content)? getFirstImageSrc(actuality?.content) : placeholderImg }
                                                        title={actuality?.title}
                                                        category={actuality?.Category?.name}
                                                        description={getTextFromHTML(actuality?.content)}
                                                        link={`${actualitiesLink}/${actuality?.id}`}
                                                        date={actuality?.createdAt}
                                                    />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
        

                    </div>
                </>

            }
        </div>
    )
}

export default ActualityDetail